import React from "react";

const pulseStyle = {
    backgroundColor: "#f0f0f0",
    borderRadius: "4px",
    animation: "skeleton-pulse 1.5s infinite ease-in-out",
};

const circleStyle = {
    ...pulseStyle,
    borderRadius: "50%",
};

const filterFrameStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
};

const SkeletonBlock = ({ width, height, style = {}, circle = false, className }) => (
    <div
        className={className}
        style={{
            ...(circle ? circleStyle : pulseStyle),
            width,
            height,
            ...style,
        }}
    />
);

const FilterHeadingSkeleton = ({ topWidth, middleWidth }) => (
    <div className="d-flex" style={filterFrameStyle}>
        <SkeletonBlock className="top" width={topWidth} height="20px" />
        <SkeletonBlock className="middle" width={middleWidth} height="20px" />
    </div>
);

const AirportOptionSkeleton = () => (
    <ul className="list-unstyled hw-search--flightCheckbox">
        <li>
            <label
                className="hw-grid--2auto"
                style={{ display: "flex", alignItems: "center" }}
            >
                <SkeletonBlock width="18px" height="18px" circle />
                <SkeletonBlock
                    width="180px"
                    height="16px"
                    className="hw-text14 hw-black900 overflow-ellipsis"
                    style={{ marginLeft: "10px" }}
                />
            </label>
        </li>
    </ul>
);

export const PriceSkeletonSideBar = () => (
    <div
        className="hw-range--line"
        style={{
            height: "0.4rem",
            backgroundColor: "#f0f0f0",
            borderRadius: "3px",
            position: "relative",
            animation: "skeleton-pulse 1.5s infinite ease-in-out",
        }}
    >
        <div
            style={{
                height: "0.4rem",
                backgroundColor: "#f0f0f0",
                position: "absolute",
                left: "0%",
                right: "0%",
                animation: "skeleton-pulse 1.5s infinite ease-in-out",
            }}
        />

        <div
            style={{
                position: "absolute",
                zIndex: 2,
                cursor: "pointer",
                userSelect: "none",
                touchAction: "none",
                height: "1.4rem",
                width: "1.4rem",
                backgroundColor: "#f0f0f0",
                border: "1px solid #f0f0f0",
                borderRadius: "50%",
                transform: "translate(-6.99653px, -5px)",
                animation: "skeleton-pulse 1.5s infinite ease-in-out",
            }}
        />

        <div
            style={{
                position: "absolute",
                zIndex: 2,
                cursor: "pointer",
                userSelect: "none",
                touchAction: "none",
                height: "1.4rem",
                width: "1.4rem",
                backgroundColor: "#f0f0f0",
                border: "1px solid #f0f0f0",
                borderRadius: "50%",
                transform: "translate(273.003px, -5px)",
                animation: "skeleton-pulse 1.5s infinite ease-in-out",
            }}
        />

        <div
            className="hw-range--text left"
            style={{
                ...pulseStyle,
                width: "65px",
                left: "-6px",
                height: "1.8rem",
            }}
        />

        <div
            className="hw-range--text right"
            style={{
                ...pulseStyle,
                width: "65px",
                height: "1.8rem",
            }}
        />
    </div>
);

export const AirlineSkeletonSideBar = () => (
    <li>
        <label className="d-flex align-items-center hw-text14 hw-gapy10">
            <SkeletonBlock width="20px" height="20px" circle />
            <SkeletonBlock
                className="hw-black900"
                width="80px"
                height="16px"
            />
            <SkeletonBlock
                className="hw-text14"
                width="30px"
                height="16px"
            />
        </label>

        <SkeletonBlock
            className="hw-text14 ms-2"
            width="60px"
            height="16px"
        />
    </li>
);

export const DurationSkeletonSideBar = () => (
    <div className="hw-search--flightFilter__frame">
        <FilterHeadingSkeleton topWidth="150px" middleWidth="80px" />
        <div className="bottom">
            <PriceSkeletonSideBar />
        </div>
    </div>
);

export const AirportSkeletonSideBar = () => (
    <>
        {[0, 1].map((item) => (
            <div className="hw-search--flightFilter__frame" key={item}>
                <FilterHeadingSkeleton topWidth="100px" middleWidth="30px" />
                <div className="bottom">
                    <AirportOptionSkeleton />
                </div>
            </div>
        ))}
    </>
);